import Vue from 'vue';
import mappingHelper from '@/helpers/mappingHelper';
import mapping from './mappings';

export default {
  // #region : Tab Handling :
  /**
   * Updates the current System Tab
   * @param {*} state
   * @param {*} tabId
   */
  setCurrentSystemTab: (state, tabId) => {
    state.currentSystemTab = tabId;
  },
  /**
   * Updates the current Product Tab
   * @param {*} state
   * @param {*} tabId
   */
  setCurrentProductTab: (state, tabId) => {
    state.currentProductTab = tabId;
  },
  /**
   * Updates the current Attribute Tab
   * @param {*} state
   * @param {*} tabId
   */
  setCurrentAttributeTab: (state, tabId) => {
    state.currentAttributeTab = tabId;
  },
  // #endregion

  // #region : Entity Selection :
  /**
   * Updates selectedSystem in state
   * @param {*} state
   * @param {*} system
   */
  setSelectedSystem: (state, system) => {
    if (system) {
      state.selectedSystem = { ...system };
    } else {
      state.selectedSystem = null;
    }
    // reset children
    state.selectedSubsystem = null;
    state.selectedComponent = null;
  },
  /**
   * Updates selected Subsystem in state
   * @param {*} state
   * @param {*} subsystem
   */
  setSelectedSubsystem: (state, subsystem) => {
    if (subsystem) {
      state.selectedSubsystem = { ...subsystem };
    } else {
      state.selectedSubsystem = null;
    }
    // reset children
    state.selectedComponent = null;
  },
  /**
   * Updates selected Component in state
   */
  setSelectedComponent: (state, component) => {
    if (component) {
      state.selectedComponent = { ...component };
    } else {
      state.selectedComponent = null;
    }
  },
  /**
   * Updates selected Product in state
   */
  setSelectedAttribute: (state, attribute) => {
    if (attribute) {
      Vue.set(state, 'selectedAttribute', { ...attribute });
    } else {
      state.selectedAttribute = null;
    }
    // reset children
    state.selectedAttributeValue = null;
  },
  /**
   * Sets selectedAttributeValue in state
   * @param {*} state
   * @param {*} attributeValue
   */
  setSelectedAttributeValue: (state, attributeValue) => {
    if (attributeValue) {
      state.selectedAttributeValue = { ...attributeValue };
    } else {
      state.selectedAttributeValue = null;
    }
  },
  /**
   * Updates selected Product in state
   */
  setSelectedProduct: (state, product) => {
    if (product) {
      state.selectedProduct = { ...product };
    } else {
      state.selectedProduct = null;
    }
    // reset children
  },
  /**
   * Updates selected Product in state
   */
  setSelectedProductAttributeValue: (state, productAttributeValue) => {
    if (productAttributeValue) {
      state.selectedProductAttributeValue = { ...productAttributeValue };
    } else {
      state.selectedProductAttributeValue = null;
    }
  },
  /**
   * Sets the selectedProductAccessory in state
   * @param {*} state
   * @param {*} productAccessory
   */
  setSelectedProductAccessory: (state, productAccessory) => {
    if (productAccessory) {
      state.selectedProductAccessory = { ...productAccessory };
    } else {
      state.selectedProductAccessory = null;
    }
  },
  /**
   * Sets the selectedProductRequirement in state
   * @param {*} state
   * @param {*} productRequirement
   */
  setSelectedProductRequirement: (state, productRequirement) => {
    if (productRequirement) {
      state.selectedProductRequirement = { ...productRequirement };
    } else {
      state.selectedProductRequirement = null;
    }
  },
  /**
   * Sets the selectedProductSetting in state
   * @param {*} state
   * @param {*} productSetting
   */
  setSelectedProductSetting: (state, productSetting) => {
    if (productSetting) {
      state.selectedProductSetting = { ...productSetting };
    } else {
      state.selectedProductSetting = null;
    }
  },
  /**
   * Sets the selectedComponentRequirement in state
   * @param {*} state
   * @param {*} componentRequirement
   */
  setSelectedComponentRequirement: (state, componentRequirement) => {
    if (componentRequirement) {
      state.selectedComponentRequirement = { ...componentRequirement };
    } else {
      state.selectedComponentRequirement = null;
    }
  },
  /**
   * Sets the selectedComponentSetting in state
   * @param {*} state
   * @param {*} componentSetting
   */
  setSelectedComponentSetting: (state, componentSetting) => {
    if (componentSetting) {
      state.selectedComponentSetting = { ...componentSetting };
    } else {
      state.selectedComponentSetting = null;
    }
  },
  /**
   * Sets the selectedProjectSetting in state
   * @param {*} state
   * @param {*} projectSetting
   */
  setSelectedProjectSetting: (state, projectSetting) => {
    if (projectSetting) {
      state.selectedProjectSetting = { ...projectSetting };
    } else {
      state.selectedProjectSetting = null;
    }
  },
  /**
   * sets the selectedProductImage in state
   * @param {*} state
   * @param {*} productImage
   */
  setSelectedProductImage: (state, productImage) => {
    state.selectedProductImage = productImage;
  },

  // #endregion

  // #region : Loading Flags :
  /**
   * Sets userListLoading in state
   *
   * @param {*} state
   * @param {*} loading
   */
  setUserListLoading: (state, loading) => {
    state.userListLoading = loading;
  },
  /**
   * Sets productImageListLoading in state
   * @param {*} state
   * @param {*} loading
   */
  setProductDetailsLoading: (state, loading) => {
    state.productDetailsLoading = loading;
  },
  /**
   * Sets subsystemByUserListLoading in state
   * @param {*} state
   * @param {*} loading
   */
  setSubsystemByUserListLoading: (state, loading) => {
    state.subsystemByUserListLoading = loading;
  },
  /**
   * Sets sellAsTypeListLoading in state
   * @param {*} state
   * @param {*} loading
   */
  setSellAsTypeListLoading: (state, loading) => {
    state.sellAsTypeListLoading = loading;
  },
  /**
   * Sets productImagesLoading flag in state
   * @param {*} state
   * @param {*} loading
   */
  setProductImagesLoading: (state, loading) => {
    state.productImagesLoading = loading;
  },
  /**
   * Sets requirementTypes loading in state
   * @param {*} state
   * @param {*} loading
   */
  setRequirementTypesLoading: (state, loading) => {
    state.requirementTypesLoading = loading;
  },
  /**
   * Sets controlTypes loading in state
   * @param {*} state
   * @param {*} loading
   */
  setControlTypesLoading: (state, loading) => {
    state.controlTypesLoading = loading;
  },
  /**
   * Sets productTypes loading in state
   * @param {*} state
   * @param {*} loading
   */
  setProductTypesLoading: (state, loading) => {
    state.productTypesLoading = loading;
  },
  /**
   * sets productsLoading in state
   * @param {*} state
   * @param {*} loading
   */
  setProductsLoading: (state, loading) => {
    state.productsLoading = loading;
  },
  /**
   * Sets attributesLoading in state
   * @param {*} state
   * @param {*} loading
   */
  setAttributesLoading: (state, loading) => {
    state.attributesLoading = loading;
  },
  /**
   * Sets attributeValuesLoading in state
   * @param {*} state
   * @param {*} loading
   */
  setAttributeValuesLoading: (state, loading) => {
    state.attributeValuesLoading = loading;
  },
  /**
   * Sets attributeValuesLoading in state
   * @param {*} state
   * @param {*} loading
   */
  setProductAttributeValuesLoading: (state, loading) => {
    state.productAttributeValuesLoading = loading;
  },
  /**
   * Sets productAccessoryLoading in state
   * @param {*} state
   * @param {*} loading
   */
  setProductAccessoriesLoading: (state, loading) => {
    state.productAccessoriesLoading = loading;
  },
  /**
   * Updates loading flag for systems
   * @param {*} state
   * @param {*} loading
   */
  setSystemsLoading: (state, loading) => {
    state.systemsLoading = loading;
  },
  /**
   * Updates loading flag for Subsystems
   * @param {*} state
   * @param {*} loading
   */
  setSubsystemsLoading: (state, loading) => {
    state.subsystemsLoading = loading;
  },
  /**
   * Sets loading flag for Components
   * @param {*} state
   * @param {*} loading
   */
  setComponentsLoading: (state, loading) => {
    state.componentsLoading = loading;
  },
  /**
   * Sets the loading flag for ProductRequirements
   * @param {*} state
   * @param {*} loading
   */
  setProductRequirementsLoading: (state, loading) => {
    state.productRequirementsLoading = loading;
  },
  /**
   * Sets the loading flag for ProductSettings
   * @param {*} state
   * @param {*} loading
   */
  setProductSettingsLoading: (state, loading) => {
    state.productSettingsLoading = loading;
  },
  /**
   * Sets the loading flag for ComponentRequirements
   * @param {*} state
   * @param {*} loading
   */
  setComponentRequirementsLoading: (state, loading) => {
    state.componentRequirementsLoading = loading;
  },
  /**
   * Sets the loading flag for ComponentSettings
   * @param {*} state
   * @param {*} loading
   */
  setComponentSettingsLoading: (state, loading) => {
    state.componentSettingsLoading = loading;
  },
  /**
   * Sets the loading flag for ProjectSettings
   * @param {*} state
   * @param {*} loading
   */
  setProjectSettingsLoading: (state, loading) => {
    state.projectSettingsLoading = loading;
  },
  // #endregion

  // #region : Entity Lists :
  /**
   * Sets the user list in state
   *
   * @param {*} state
   * @param {*} data
   */
  setUserList: (state, data) => {
    state.userList = data;
  },
  /**
   * Sets the subsystemByUserList in state
   *
   * @param {*} state
   * @param {*} data
   */
  setSubsystemByUserList: (state, data) => {
    state.subsystemByUserList = data;
  },
  /**
   * Updates the product image list in state
   * @param {*} state
   * @param {*} data
   */
  setProductImageList: (state, data) => {
    state.productImageList = [];
    console.log('updating productimagelist');
    data.forEach((x, i) => {
      Vue.set(
        state.productImageList,
        i,
        mappingHelper.mapApiToVue(
          mapping.productImageMapDefinition,
          x,
          state,
          false
        )
      );
    });
  },
  setSellAsTypeList: (state, data) => {
    state.sellAsTypeList = [];
    console.log('updating sellAsTypeList');
    data.forEach((x, i) => {
      Vue.set(
        state.sellAsTypeList,
        i,
        mappingHelper.mapApiToVue(
          mapping.sellAsTypeMapDefinition,
          x,
          state,
          false
        )
      );
    });
  },
  /**
   * Sets the product list
   * @param {*} state
   * @param {*} data
   */
  setProductList: (state, data) => {
    state.productList = [];

    data.forEach((x, i) => {
      Vue.set(
        state.productList,
        i,
        mappingHelper.mapApiToVue(mapping.productMapDefinition, x, state, false)
      );
    });
  },
  /**
   * Sets the attribute list
   * @param {*} state
   * @param {*} data
   */
  setAttributeList: (state, data) => {
    state.attributeList = [];
    data.forEach((x, i) => {
      Vue.set(
        state.attributeList,
        i,
        mappingHelper.mapApiToVue(
          mapping.attributeMapDefinition,
          x,
          state,
          false
        )
      );
    });
  },
  /**
   * Sets the attributeValue list
   * @param {*} state
   * @param {*} data
   */
  setAttributeValueList: (state, data) => {
    state.attributeValueList = [];
    data.forEach((x, i) => {
      Vue.set(
        state.attributeValueList,
        i,
        mappingHelper.mapApiToVue(
          mapping.attributeValueMapDefinition,
          x,
          state,
          false
        )
      );
    });
  },
  /**
   * Sets the product list
   * @param {*} state
   * @param {*} data
   */
  setProductTypeList: (state, data) => {
    state.productTypeList = [];
    data.forEach((x, i) => {
      Vue.set(
        state.productTypeList,
        i,
        mappingHelper.mapApiToVue(
          mapping.productTypeMapDefinition,
          x,
          state,
          false
        )
      );
    });
  },
  /**
   * Sets the System List
   * @param {*} state
   * @param {*} data
   */
  setSystemList: (state, data) => {
    state.systemList = [];
    data.forEach((x, i) => {
      Vue.set(
        state.systemList,
        i,
        mappingHelper.mapApiToVue(mapping.systemMapDefinition, x, state, false)
      );
    });
  },
  /**
   * Sets the Subsystem List in State
   * @param {*} state
   * @param {*} data
   */
  setSubsystemList: (state, data) => {
    state.subsystemList = [];
    data.forEach((x) => {
      state.subsystemList.push({
        id: x.id,
        systemDefinitionId: x.systemDefinitionId,
        name: x.name,
        description: x.description,
        subsystemType: x.subsystemType,
        userType: x.userType,
        published: x.published
      });
    });
  },
  /**
   * Sets the Component List in State
   */
  setComponentList: (state, data) => {
    Vue.set(state, 'componentList', []);
    data.forEach((x, i) => {
      Vue.set(
        state.componentList,
        i,
        mappingHelper.mapApiToVue(
          mapping.componentMapDefinition,
          x,
          state,
          false
        )
      );
    });
  },
  /**
   * Sets AttributeValueList in state
   * @param {*} state
   * @param {*} data
   */
  setProductAttributeValueList: (state, data) => {
    Vue.set(state, 'productAttributeValueList', []);
    data.forEach((x, i) => {
      Vue.set(
        state.productAttributeValueList,
        i,
        mappingHelper.mapApiToVue(
          mapping.productAttributeValueMapDefinition,
          x,
          state,
          false
        )
      );
    });
  },
  /**
   * Sets ProductAccessoryList in state
   * @param {*} state
   * @param {*} data
   */
  setProductAccessoryList: (state, data) => {
    Vue.set(state, 'productAccessoryList', []);
    data.forEach((x, i) => {
      Vue.set(
        state.productAccessoryList,
        i,
        mappingHelper.mapApiToVue(
          mapping.productAccessoryMapDefinition,
          x,
          state,
          false
        )
      );
    });
  },
  /**
   * Sets the ControlType list in state
   * @param {*} state
   * @param {*} data
   */
  setControlTypeList: (state, data) => {
    Vue.set(state, 'controlTypeList', []);
    data.forEach((x, i) => {
      Vue.set(
        state.controlTypeList,
        i,
        mappingHelper.mapApiToVue(
          mapping.controlTypeMapDefinition,
          x,
          state,
          false
        )
      );
    });
  },
  /**
   * Sets the RequirementType list in state
   * @param {*} state
   * @param {*} data
   */
  setRequirementTypeList: (state, data) => {
    Vue.set(state, 'requirementTypeList', []);
    data.forEach((x, i) => {
      Vue.set(
        state.requirementTypeList,
        i,
        mappingHelper.mapApiToVue(
          mapping.requirementTypeMapDefinition,
          x,
          state,
          false
        )
      );
    });
  },
  /**
   * Sets the ProductRequirementList in state
   * @param {*} state
   * @param {*} data
   */
  setProductRequirementList: (state, data) => {
    Vue.set(state, 'productRequirementList', []);
    data.forEach((x, i) => {
      Vue.set(
        state.productRequirementList,
        i,
        mappingHelper.mapApiToVue(
          mapping.productRequirementMapDefinition,
          x,
          state,
          false
        )
      );
    });
  },
  /**
   * Sets the ProductSettingList in state
   * @param {*} state
   * @param {*} data
   */
  setProductSettingList: (state, data) => {
    Vue.set(state, 'productSettingList', []);
    data.forEach((x, i) => {
      Vue.set(
        state.productSettingList,
        i,
        mappingHelper.mapApiToVue(
          mapping.productSettingMapDefinition,
          x,
          state,
          false
        )
      );
    });
  },
  /**
   * Sets the ComponentRequirementList in state
   * @param {*} state
   * @param {*} data
   */
  setComponentRequirementList: (state, data) => {
    Vue.set(state, 'componentRequirementList', []);
    data.forEach((x, i) => {
      Vue.set(
        state.componentRequirementList,
        i,
        mappingHelper.mapApiToVue(
          mapping.componentRequirementMapDefinition,
          x,
          state,
          false
        )
      );
    });
  },
  /**
   * Sets the ComponentSettingList in state
   * @param {*} state
   * @param {*} data
   */
  setComponentSettingList: (state, data) => {
    Vue.set(state, 'componentSettingList', []);
    data.forEach((x, i) => {
      Vue.set(
        state.componentSettingList,
        i,
        mappingHelper.mapApiToVue(
          mapping.componentSettingMapDefinition,
          x,
          state,
          false
        )
      );
    });
  },
  /**
   * Sets the ProjectSettingList in state
   * @param {*} state
   * @param {*} data
   */
  setProjectSettingList: (state, data) => {
    Vue.set(state, 'projectSettingList', []);
    data.forEach((x, i) => {
      Vue.set(
        state.projectSettingList,
        i,
        mappingHelper.mapApiToVue(
          mapping.projectSettingMapDefinition,
          x,
          state,
          false
        )
      );
    });
  },
  /**
   * Sets the RequirementEntityList in state
   * @param {*} state
   * @param {*} data
   */
  setRequirementEntityList: (state, data) => {
    Vue.set(state, 'requirementEntityList', []);
    data.forEach((x, i) => {
      Vue.set(
        state.requirementEntityList,
        i,
        mappingHelper.mapApiToVue(
          mapping.controlTypeMapDefinition,
          x,
          state,
          false
        )
      );
    });
  },
  /**
   * Sets the UserTypeList in state
   * @param {*} state
   * @param {*} data
   */
  setUserTypeList: (state, data) => {
    Vue.set(state, 'userTypeList', []);
    data.forEach((x, i) => {
      Vue.set(
        state.userTypeList,
        i,
        mappingHelper.mapApiToVue(
          mapping.userTypeMapDefinition,
          x,
          state,
          false
        )
      );
    });
  },
  // #endregion

  // #region : Dialogs :
  setShowEditSystemDialog: (state, showDialog) => {
    state.showEditSystemDialog = showDialog;
  },
  setShowEditSubsystemDialog: (state, showDialog) => {
    state.showEditSubsystemDialog = showDialog;
  },
  setShowEditComponentDialog: (state, showDialog) => {
    state.showEditComponentDialog = showDialog;
  },
  // #endregion

  // #region : Generic State Update Handlers :
  /**
   * Handles selection model manipulation
   * @param {*} state
   * @param {*} payload
   */
  setSelectionModel: (state, payload) => {
    if (!payload.value) payload.value = [];
    Vue.set(state, payload.entity, payload.value);
  },
  /**
   * Updates a system property and sets dirty flag
   * @param {*} state
   * @param {*} payload
   */
  updateEntityProperty: (state, payload) => {
    state[payload.entity].dirty = true;
    Vue.set(state[payload.entity], payload.property, payload.value);
  }
  // #endregion
};
